export default __webpack_public_path__ + "static/media/vip-active.43329a15.svg";